import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PlacesRoutingModule, routedPlacesComponents } from './places.routing';
import { PlaceService } from './place.service';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { PlaceComponent } from './place.component';
import { TabModule } from '../../blocks/tabs/tab.module';

@NgModule({
    imports: [PlacesRoutingModule, SharedModule, CommonModule, FormsModule,TabModule],
    declarations: [routedPlacesComponents,],
    providers: [PlaceService],
    exports: [PlaceComponent]
})
export class PlacesComponent { }
